import { render } from "./DefaultResource.vue?vue&type=template&id=22251b14&scoped=true"
import script from "./DefaultResource.vue?vue&type=script&lang=js"
export * from "./DefaultResource.vue?vue&type=script&lang=js"

import "./DefaultResource.vue?vue&type=style&index=0&id=22251b14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22251b14"

export default script